export const PT_TRANSLATIONS = {
	translation: {
		BUTTON_TEXT_PRE_APP: 'Enviar',
		DIAL_COUNTRY_SELECTOR: 'País',
		COUNTRY_SELECTOR: 'País',
		DOCUMENT_TYPE_SELECTOR: 'Selecione seu tipo de documento',
		BUTTON_LOADING: '... Enviando',
		TAB_TITLE: 'Latú - Seguro empresarial movido por tecnologia',
		PRE_APPLICATION_TAB_TITLE: 'Let’s cover your Business',
		STEPS_TITLE: 'Passos',
		NEXT: 'Próximo',
		BACK: 'Voltar',
		YES: 'Sim',
		NOT: 'Não',
		COMPLETE: 'Concluído',
		QUOTE_INTRO_1: `Temos ótimas notícias! Preparamos propostas personalizadas para atender às demandas da sua empresa.`,
		QUOTE_INTRO_2: 'Produto: ',
		QUOTE_INTRO_3: `Por favor, selecione a opção que melhor se adequa às suas preferências. Cada proposta oferece coberturas diferentes.`,
		QUOTE_INTRO_RECOMMENDATION_LIMIT: 'Recomendação de Limite: ',
		QUOTE_COVERAGE_TITLE: 'Coberturas da apólice',
		QUOTE_COVERAGE_SUBTITLE:
			'Essa é a quantia máxima que a seguradora irá pagar em caso de sinistro.',
		QUOTE_PREMIUM_TITLE: 'Prêmio:',
		QUOTE_PREMIUM_SUBTITLE: 'Valor a ser pago para a cobertura.',
		QUOTE_COUNTRIES_COVERAGE_TITLE: 'Países com cobertura:',
		QUOTE_CONTRACT_COVERAGES_TITLE: 'Coberturas do contrato:',
		QUOTE_EXCLUSIONS_TITLE: 'Exclusões:',
		QUOTE_ADDITIONAL_COVERAGES_TITLE: 'Coberturas Adicionais:',
		QUOTE_OTHER_CONDITIONS_TITLE: 'Outras condições:',
		QUOTE_PAYMENT_SCHEDULE_TITLE: 'Condições de pagamento:',
		QUOTE_PAYMENT_SCHEDULE:
			'até 4 parcelas sem juros ou 7 parcelas com juros de 1.5% ao mês.',
		QUOTE_MORE_INFO:
			'Na Latú, estamos comprometidos em ajudá-lo em todas as etapas da sua jornada, então, se precisar de ajuda ou tiver dúvidas, basta nos enviar uma mensagem ou marcar uma reunião - nossa equipe ficará feliz em orientá-lo.',
		QUOTE_SCHEDULE_MEET: 'Agende uma reunião',
		QUOTE_INSTALLMENTS_INFO: '{{numberOfInstallments}} parcelas de {{value}}',
		QUOTE_SELECT_BUTTON: 'Confirme',
		QUOTE_SUCCESS_MESSAGE:
			'Obrigado por escolher-nos! Nossa equipe de profissionais de seguros entrará em contato com você em breve para iniciar o processo.',
		DENIED_TITLE: 'NEGADO',
		DENIED_SUB_TITLE: 'A companhia de seguros negou o acesso a uma apólice',
		MANDATORY_FIELD: 'Preenchimento Obrigatório',
		YES_LABEL: 'Sim',
		NOT_LABEL: 'Não',
		SUCCESS_TITLE: 'Obrigada!',
		SUCCESS_SUB_TITLE: 'Entraremos em contato em breve.',
		SUCCESS_BUTTON_BACK: 'Voltar para a página inicial',
		USER_TYPE_SELECTION_PAGE_TITLE: 'Conhecendo seu negócio',
		USER_TYPE_SELECTION_PAGE_SUB_TITLE:
			'Olá! É muito bom ter você aqui. Para começar, nos informe:',
		USER_TYPE_SELECTION_PAGE_PJ_SELECTION: 'Sou uma empresa',
		USER_TYPE_SELECTION_PAGE_PJ_SELECTION_DESC:
			'Sou uma empresa com CNPJ buscando seguros',
		USER_TYPE_SELECTION_PAGE_PF_SELECTION: 'Sou pessoa física',
		USER_TYPE_SELECTION_PAGE_PF_SELECTION_DESC:
			'Sou uma pessoa com CPF buscando seguros',
		PLACEHOLDER_FULL_NAME: 'Nome completo',
		HOME: 'Início',
		HOME_PAGE_MENU: 'Página inicial',
		COVERAGE_PAGE_MENU: 'Produtos Latú',
		QUOTES_PAGE_MENU: 'Cotações',
		BANK_DETAILS_MENU: 'Dados bancários',
		PROFILE_SETTINGS_MENU: 'Configurações de perfil',
		HELP_CENTRAL_MENU: 'Central de ajuda',
		LOGOUT_MENU: 'Sair',
		LOGOUT_MENU_CANCEL: 'Cancelar',
		LOGOUT_CONFIRMATION: 'Você tem certeza que deseja sair?',
		EARNING_MENU: 'Controle de comissões',
		BANNER_INFO_EXPERIENCE_TO_TAKE_RISKS:
			'Experimente a tranquilidade de poder arriscar. Faça sua cotação de coberturas.',
		BANNER_INFO_CA_QUOTE_NOW: 'Cotar agora',
		ALERT_INFO_COVERAGE_YOUR_NEEDS:
			'Não sabe qual seguro se encaixa em suas necesidades?',
		ALERT_INFO_CA_FIND_OUT_HERE: 'Descubra aqui',
		COVERAGE_PAGE_TITLE: 'Quais seguros você está buscando?',
		COVERAGE_PAGE_SUB_TITLE:
			'Para trazer a melhor opção para você, selecione um ou mais seguros que sua empresa precisa. ',
		DYO_CARD_TITLE: 'Director & Officers',
		DYO_CARD_DESCRIPTION:
			'Proteção para gestores perante reclamações ligadas a sua administração.',
		PROFESSIONAL_RESPONSIBILITY_CARD_TITLE: 'Responsabilidade Profissional',
		PROFESSIONAL_RESPONSIBILITY_CARD_DESCRIPTION:
			'Cobre sua empresa contra prejuízos sofridos por clientes que alegam erros de seu serviço.',
		CYBER_CARD_TITLE: 'Seguro Cyber',
		CYBER_CARD_DESCRIPTION:
			'Proteção perante ameaças cibernéticas como ataques hackers e vazamento de dados.',
		CARD_TEXT_BUTTON_CALLBACK: 'Selecionar',
		CARD_TEXT_LINK_CALLBACK: 'Mais informações',
		MODAL_WANT_TO_TALK_TITLE: 'Como deseja contatar nossa equipe?',
		MODAL_WANT_TO_TALK_SUB_TITLE:
			'Estamos aqui para te ajudar! Escolha a melhor forma para contato:',
		MODAL_WANT_TO_TALK_WHATSAPP_TITLE: 'WhatsApp',
		MODAL_WANT_TO_TALK_WHATSAPP_INFO:
			'Converse com nossa equipe de especialistas',
		MODAL_WANT_TO_TALK_SCHEDULED_TITLE: 'Agende uma reunião',
		MODAL_WANT_TO_TALK_SCHEDULED_INFO:
			'Fale conosco e tenha todas suas dúvidas sanadas.',
		MODAL_WANT_TO_TALK_EMAIL_INFO: 'Entre em contato com nosso time de experts',
		SIDEBAR_COMPANY_INFORMATION_TITLE: 'Informações da empresa',
		SIDEBAR_LABEL_COMPANY_NAME: 'Nome da empresa',
		SIDEBAR_LABEL_FULL_NAME: 'Nome do funcionário',
		SIDEBAR_LABEL_EMAIL: 'E-mail do funcionário',
		SIDEBAR_LABEL_WEBSITE: 'Site da empresa',
		SIDEBAR_LABEL_ADMIN_EMAIL: 'Nome do administrador',
		SIDEBAR_LABEL_ADMIN_FULL_NAME: 'E-mail do administrador',
		SIDEBAR_COMPANY_INFORMATION_EDIT_BUTTON: 'Enviar datos',
		ALERT_INFO_HAS_INSURANCE: 'Possui seguros com a Latú',
		ALERT_INFO_DONT_HAS_INSURANCE: 'Não possui seguros com a Latú',
		DRAG_AND_DROP_FILE_TEXT: 'Arraste e solte o arquivo aqui',
		TOTAL_EMPLOYEES_COPY: 'Total de funcionários',
		IPAF_TAB_TITLE: 'Application Form',
		FINISH: 'Terminar',
		SUCCESS_UPLOAD_FILE:
			'We have received your file now you can continue with the process',
		IPAF_SUCCESS_TITLE: 'Agradecemos as informações',
		IPAF_SUCCESS_SUBTITLE:
			'Nosso time irá trabalhar o mais rápido possível para trazer uma cotação para seu negócio.',
		IPAF_SUCCESS_DETAIL_TITLE: 'Tempo de espera',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_1:
			'O processo de análise leva de 10 a 15 dias úteis.',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_2:
			'Fique tranquilo, vamos manter você atualizado de todas as novidades no processo!',
		IPAF_SUCCESS_DETAIL_COPY_INTRO_3: 'Entenda o processo de contratação',
		IPAF_SUCCESS_STEP_1: 'Preenchimento de dados',
		IPAF_SUCCESS_STEP_2: 'Análises de cotação',
		IPAF_SUCCESS_STEP_3: 'Apresentação de prosposta de cotação',
		IPAF_SUCCESS_STEP_4: 'Cobertura ativa',
		IPAF_SUCCESS_STEP_HERE: 'Você está aqui!',
		ERROR_NAME_EMPTY: 'O nome não pode estar vazio',
		LINK_ADDITIONAL_UPLOAD_COPY: 'Modelo para você copiar e editar',
		TALK_WITH_EXPERT_TITLE: 'Fale com seu expert em seguro',
		TALK_WITH_EXPERT_COPY:
			'Conte com um atendimento personalizado para sua conta ',
		ALL_SET_TITLE: 'Ative a sua conta',
		ALL_SET_COPY:
			'Por favor, clique no link que enviamos para {{email}} para verificar sua conta e continuar.',
		PO: 'Português',
		SP: 'Espanhol',
		ES: 'Espanhol',
		EN: 'Inglês',
		BR: 'Brasil',
		MX: 'México',
		CO: 'Colômbia',
		US: 'Estados Unidos',
		IPAF_PENDING_ALERT_TITLE: 'Você tem um formulário em andamento.',
		IPAF_PENDING_ALERT_INTRO:
			'Complete o preenchimento do seu formulário e obtenha uma cotação de seguro.',
		IPAF_PENDING_ALERT_TEXT_CALL_TO_ACTION: 'Finalizar formulário',
		MODAL_IPAF_CONFIRMATION_TITLE:
			'Você tem certeza de que deseja terminar mais tarde? ',
		MODAL_IPAF_CONFIRMATION_SUB_TITLE: 'Seu progresso será salvo.',
		MODAL_IPAF_CONFIRMATION_BUTTON_CONTINUE: 'Continuar preenchendo',
		MODAL_IPAF_CONFIRMATION_BUTTON_SAVE: 'Terminar mais tarde',
		LIGHT_TABLE_TITLE: 'Seus processos por status',
		LIGHT_TABLE_HEADER_PROCESS_NAME: 'Nome',
		LIGHT_TABLE_HEADER_UPDATED_AT: 'Última atualização',
		LIGHT_TABLE_HEADER_STATUS: 'Status',
		LIGHT_TABLE_HEADER_ACTION: 'Ação',
		IPAF_STATUS_IN_PROGRESS: 'Em andamento',
		IPAF_STATUS_PENDING_REVIEW: 'Em andamento',
		IPAF_STATUS_EXPIRED: 'Expirado',
		IPAF_STATUS_QUOTING: 'Em cotação',
		IPAF_STATUS_QUOTE_READY: 'Cotação Pronta',
		LIGHT_TABLE_LINK_ACTION_CONTINUE: 'Retomar',
		LIGHT_TABLE_LINK_ACTION_VIEW_EDIT_QUESTIONS: 'Retomar',
		LIGHT_TABLE_LINK_ACTION_VIEW_QUOTE: 'Ver cotação',
		SELECT_PRODUCT_COPY: 'Selecionar produto',
		ACTION_CLOSE_FROM_SUCCESS_PAGE: 'Fechar',
		QUESTION_CONFIRMATION_WELCOME_TITLE:
			'Bem-vindo ao Formulário de Seguro para Empresas da Latú',
		QUESTION_CONFIRMATION_INFO:
			'Antes de preencher nosso formulário, confira essas 3 super dicas:',
		QUESTION_CONFIRMATION_CAPTION:
			'*Caso precise, utilize o botão de voltar para revisar perguntas que já respondeu.',
		QUESTION_CONFIRMATION_SECURE_DATA_TITLE: 'Seus dados estarão seguros:',
		QUESTION_CONFIRMATION_SECURE_DATA_SUB_TITLE:
			'Nós levamos a segurança a sério e implementamos todas as medidas para garantir a confidencialidade e a segurança de suas informações.',
		QUESTION_CONFIRMATION_NEEDS_TITLE:
			'Suas informações ficarão sempre salvas.',
		QUESTION_CONFIRMATION_NEEDS_SUB_TITLE:
			'Buscaremos a melhor solução para sua empresa e, para isso, precisamos de algumas informações. Se precisar parar, seu progresso será salvo e você poderá continuar posteriormente de onde parou.',
		QUESTION_CONFIRMATION_WE_ARE_FOR_YOU_TITLE:
			'Estamos aqui para o que precisar:',
		QUESTION_CONFIRMATION_WE_ARE_FOR_YOU_SUB_TITLE:
			'Nosso time está sempre disponível e ficaremos felizes em ajudar ou responder a quaisquer dúvidas que você tenha. Clique no botão de chat se tiver alguma pergunta durante o processo.',
		QUESTION_CONFIRMATION_BUTTON_CONTINUE: 'Próximo',
		QUESTION_CONFIRMATION_BUTTON_START: 'Iniciar',
		WELCOME_MESSAGE: 'Bem vindo',
		CONFIRMATION_MODAL_START_NEW_IPAF_TITLE:
			'Você já tem um processo em andamento',
		CONFIRMATION_MODAL_START_NEW_IPAF_INTRO:
			'Se você começar um processo novo, as informações atuales serão perdidas.',
		CONFIRMATION_MODAL_START_NEW_IPAF_INTRO_1:
			'será substituído por esse novo.',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_TO_CONTINUE: 'Deseja continuar?',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_BUTTON_ACTION_CONTINUE_OLD:
			'Continuar o processo atual',
		CONFIRMATION_MODAL_START_NEW_IPAF_QUESTION_BUTTON_ACTION_CONTINUE_NEW:
			'Começar um processo novo',
		BUTTON_START_NEW_IPAF: 'Iniciar',
		ANSWER_PAGE_TITLE: 'Confirme as informações',
		ANSWER_PAGE_INTRO:
			'Certifique-se de que todas as informações estejam corretas antes de finalizar. Estas informações serão utilizadas para fornecer a cobertura de seguro apropriada para o seu negócio.',
		ANSWER_PAGE_BUTTON: 'Avançar',
		COVERAGE_DETAIL_PAGE_BACK_TO_HOME_LINK:
			'Voltar para página inicial de Cotações',
		COVERAGE_DETAIL_PAGE_TITLE: 'Cotações para: {{insurance_name}}',
		COVERAGE_DETAIL_PAGE_SUB_TITLE:
			'Selecione a cotação que faz sentido para sua empresa:',
		COVERAGE_DETAIL_PAGE_BANNER_TITLE: 'O que é o seguro {{insurance_name}}?',
		COVERAGE_DETAIL_PAGE_BANNER_SUB_TITLE:
			'É uma proteção pensada para gestores e todos que compõem a administração e liderança da empresa.',
		COVERAGE_DETAIL_PAGE_BANNER_MORE_INFO: 'Quer saber mais?',
		COVERAGE_DETAIL_PAGE_BANNER_CLICK_INFO: 'Clique aqui',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGE_TEXT: 'Cobertura',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGE_SELECTED_TEXT:
			'A compensação máxima fornecida pela seguradora em caso de sinistro é de {{coverage_selected}}.',
		COVERAGE_DETAIL_PAGE_QUOTE_GROSS_TEXT: 'Prêmio Total',
		COVERAGE_DETAIL_PAGE_QUOTE_EXPIRED_TEXT: 'Cotação expira em:',
		COVERAGE_DETAIL_PAGE_QUOTE_AMOUNT_TO_PAID_TEXT:
			'Valor a ser pago pela cobertura',
		COVERAGE_DETAIL_PAGE_QUOTE_WITH_FEES_TEXT: 'com taxas',
		COVERAGE_DETAIL_PAGE_QUOTE_WITH_OUT_FEES_TEXT: 'mais taxas',
		COVERAGE_DETAIL_PAGE_QUOTE_SELECT_TEXT: 'Contratar seguro',
		COVERAGE_DETAIL_PAGE_QUOTE_SELECTED_TEXT: 'Cotação selecionada',
		COVERAGE_DETAIL_PAGE_QUOTE_COVERAGES_TEXT: 'Coberturas',
		COVERAGE_DETAIL_PAGE_QUOTE_EXCLUSIONS_TEXT: 'Exclusões',
		COVERAGE_DETAIL_PAGE_QUOTE_MORE_TEXT: '+{{total_coverages}}',
		COVERAGE_DETAIL_PAGE_QUOTE_VIEW_MORE_DETAIL_TEXT: 'Ver mais informações',
		COVERAGE_DETAIL_PAGE_QUOTE_DOWNLOAD_FULL_COVERAGE_TEXT:
			'Baixar cotação completa',
		COVERAGE_DETAIL_PAGE_QUOTE_DO_YOU_NEED_HELP_TEXT:
			'Precisa de ajuda com as cotações?',
		COVERAGE_DETAIL_PAGE_QUOTE_SPEAK_AN_EXPERT_TEXT: 'Fale com um especialista',
		QUOTE_RECOMMENDED_TEXT: 'Recomendado',
		QUOTE_MODAL_MORE_INFO_TITLE: 'Informações sobre a cotaçao',
		QUOTE_MODAL_COVERAGE_TITLE: 'Coberturas da apólice',
		QUOTE_MODAL_EXCLUSIONS_TITLE: 'Exclusões',
		QUOTE_MODAL_PAYMENT_TITLE: 'Pagamento',
		QUOTE_MODAL_RETRO_ACTIVITY_TITLE: 'Retroatividade',
		QUOTE_MODAL_SCOPE_TITLE: 'Âmbito Territorial',
		QUOTE_MODAL_SUSEP_CODE_TITLE: 'Código de seguro',
		QUOTE_MODAL_WE_NEED_TEXT:
			'Precisamos obter uma assinatura de um signatário legal da empresa para iniciar o processo de emissão.',
		QUOTE_MODAL_DO_YOU_WANT_TEXT: 'Deseja confirmar a cotação?',
		QUOTE_MODAL_CONTRACT_CALL_TO_ACTION_TEXT: 'Contratar',
		QUOTE_MODAL_CANCEL_TEXT: 'Cancelar',
		QUOTE_SUCCESS_MODAL_TITLE: 'Parabéns pela escolha!',
		QUOTE_SUCCESS_MODAL_INFO:
			'Enviaremos um e-mail para {{email}} para confirmar as informações enviadas e a cobertura selecionada.',
		QUOTE_SUCCESS_MODAL_INTRO:
			'Após a confirmação solicitada, iremos iniciar o processo de emissão em conjunto com a seguradora. Caso não seja requerida nenhuma documentação ou informação adicional, esperamos obter a apólice em até 15 dias.',
		EXPIRED: 'Expirada',
		REMOVE: 'Remover',
		QUOTE_PAGE_TITLE: 'Cotações',
		QUOTE_PAGE_SUB_TITLE:
			'Confira os orçamentos disponíveis e acompanhe o status das cotações. O status será atualizado sempre que houver progresso da solicitação ',
		QUOTE_PAGE_BANNER_TITLE: 'Precisa de ajuda com as cotações?',
		QUOTE_PAGE_BANNER_CALL_TO_ACTION: 'Fale com um especialista',
		QUOTE_BLOCK_SEARCHING_QUOTE_TITLE: 'Buscando cotação',
		QUOTE_BLOCK_AVAILABLE_QUOTES_TITLE: 'Cotações disponíveis',
		QUOTE_BLOCK_EMISSION_QUOTES_TITLE: 'Cotações em emissão',
		QUOTE_BLOCK_EXPIRED_QUOTES_TITLE: 'Cotações expiradas',
		QUOTE_CARD_PRODUCT_TITLE: 'Cotações para o produto',
		QUOTE_CARD_APPLICATION_DATE_TEXT: 'Data de solicitação:',
		QUOTE_CARD_SEARCH_QUOTE_TEXT: 'Buscando cotação',
		QUOTE_CARD_EXPIRATION_DATE_TEXT: 'Cotação expira em:',
		QUOTE_CARD_VIEW_DETAIL_LINK: 'Ver cotações',
		QUOTE_CARD_INSURER_TEXT: 'Seguradora:',
		QUOTE_CARD_MAXIMUM_COVERAGE_TEXT:
			'Valor máximo coberto em caso de sinistro',
		QUOTE_VALID_FOR: 'Cotações válidas para:',
		EDIT: 'Editar',
		BACK_LINK: 'Voltar',
		QUOTE_PAGE_DONT_HAVE_QUOTES_TEXT:
			'No momento não temos cotações disponíveis.',
		QUOTE_PAGE_START_YOUR_QUOTE_TEXT:
			'Inicie o seu processo de cotação agora mesmo.',
		QUOTE_PAGE_QUOTE_TEXT_BUTTON: 'Cotar agora',
		IPAF_STATUS_CLOSED: 'Concluído',
		SIGN_IN_TEXT: 'Entrar',
		POLICIES_PAGE_MENU: 'Minhas apólices',
		POLICIES_PAGE_TITLE: 'Minhas apólices',
		POLICIES_PAGE_SUB_TITLE:
			'Visualize e gerencie as apólices contratadas pela sua empresa',
		TAB_POLICY_ACTIVE: 'Vigências ativas',
		TAB_POLICY_EXPIRED: 'Vigências expiradas',
		PREAPP_LIST_ITEM_1:
			'Cadastre-se para criar sua conta e iniciar o processo de cotação.',
		PREAPP_LIST_ITEM_2:
			'Gerencie todas as questões relacionadas ao seu seguro com a Latú.',
		ALREADY_ACCOUNT_TEXT: 'Já possui uma conta?',
		ALREADY_ACCOUNT_TEXT_LINK: 'Faça login',
		PAID: 'Pago',
		PENDING: 'Pendente',
		LATE: 'Atrasado',
		DELAYED: 'Atrasado',
		IN_QUEUE: 'Pendente',
		POLICY_CARD_POLICY_HOLDER: 'Tomador do seguro',
		POLICY_CARD_INSURANCE_COMPANY: 'Seguradora',
		POLICY_CARD_INSURANCE_EXPIRATION: 'Vencimento',
		POLICY_CARD_VIEW_POLICY_TEXT: 'Ver apólice',
		POLICY_DETAIL_GENERAL_INFORMATION_TITLE: 'Informações gerais',
		POLICY_DETAIL_INSURANCE_NAME_TITLE: 'Sobre o {{insurance_name}}',
		POLICY_DETAIL_COVERAGES_AND_EXCLUSIONS_TITLE: 'Coberturas e exclusões',
		POLICY_DETAIL_COVERAGE_TITLE: 'Coberturas do seguro',
		POLICY_DETAIL_COVERAGE_EXCLUSIONS_TITLE: 'Exclusões do seguro',
		POLICY_DETAIL_DOWNLOAD_POLICY: 'Baixar apólice completa',
		POLICY_DETAIL_DETAIL_POLICY: 'Ver mais detalhes da apólice',
		POLICY_DETAIL_COVERAGE_LIMIT: 'Limite máximo de garantia',
		POLICY_DETAIL_TOTAL_COVERAGE: 'Limite máximo de garantia',
		POLICY_DETAIL_SUB_LIMITS_TITLE: 'Fique atento aos sublimites!',
		POLICY_DETAIL_SUB_LIMITS_TEXT:
			'Sublimites restringem o valor máximo de uma cobertura para certos riscos ou danos. Para mais informações, verifique a sua apólice.',
		POLICY_DETAIL_MAX_COVERAGE_INFO: 'Valor máximo coberto em caso de sinistro',
		POLICY_DETAIL_PERIOD_INFO: 'Vigência',
		POLICY_DETAIL_EFFECTIVE_DATE: 'Vigência',
		POLICY_START_AND_END_DATE:
			'Data de início e término da vigência da apólice',
		POLICY_DETAIL_PLAN_ANNUAL: 'Plano anual',
		POLICY_DETAIL_PAYMENT_TITLE: 'Pagamento',
		POLICY_DETAIL_PAYMENT_SUB_TITLE: 'Acompanhe os pagamentos do seguro.',
		POLICY_DETAIL_TOTAL_AMOUNT_BE_PAID: 'Valor total a pagar:',
		POLICY_DETAIL_PAYMENT_TYPE: 'Tipo de pagamento:',
		POLICY_DETAIL_NEXT_PAYMENT: 'Próximo pagamento em:',
		POLICY_TABLE_INVOICE_TITLE: 'Faturas',
		POLICY_TABLE_EXPIRATION_TITLE: 'Data de vencimento',
		POLICY_TABLE_VALUE_TITLE: 'Valor',
		POLICY_TABLE_DOWNLOAD_TITLE: 'Baixar',
		POLICY_DETAIL_PAYMENT_STATUS_INFO:
			'O status de pagamento é atualizado semanalmente.',
		POLICY_DETAIL_REPORT_CLAIM_TEXT_A: 'Precisa comunicar um sinistro?',
		POLICY_DETAIL_REPORT_CLAIM_TEXT_B: 'Estamos aqui para te ajudar!',
		POLICY_DETAIL_REPORT_CLAIM_LINK: 'Comunicar sinistro',
		COVERAGE_DETAIL_PAGE_POLICY_DOWNLOAD_FULL_COVERAGE_TEXT:
			'Baixar apólice completa',
		POLICY_DETAIL_DATA_ZERO_TEXT:
			'Estamos trabalhando para trazer seus dados de pagamento. Em breve, você poderá acompanhá-los aqui!',
		SELECTED_QUOTE_TEXT: 'Cotação selecionada:',
		CLOSE_AND_REDIRECT_QUOTES_HOME: 'Ir para menu cotações',
		COMPANY_STRUCTURE_ADD_BUTTON_TEXT: 'Adicionar empresa',
		COMPANY_STRUCTURE_INFO_TEXT: 'Pode adicionar mais de um cliente',
		COMPANY_REVENUE_DISTRIBUTION_INFO_TEXT: 'Pode adicionar mais de uma pessoa',
		COMPANY_REVENUE_INDUSTRY_PERCENTAGE_INFO_TEXT:
			'Preencha apenas os que se aplicam ao seu negócio',
		COMPANY_REVENUE_PERCENTAGE_INFO_TEXT:
			'Preencha apenas os que se aplicam ao seu negócio',
		ADD_COMPANY_MEMBERS_TEXT: 'Adicionar membros da empresa',
		ADD_COMPANY_TEXT: 'Adicionar empresa',
		EDIT_COMPANY_TEXT: 'Editar empresa',
		BANNER_PROGRESS_IPAF_TITLE: 'Você tem um formulário em andamento!',
		BANNER_PROGRESS_IPAF_TEXT:
			'Finalize o formulário para receber sua cotação.',
		BANNER_PROGRESS_IPAF_CALL_TO_ACTION: 'Finalizar formulário',
		UNAVAILABLE_TEXT: 'Indisponível:',
		PURCHASE_INSURANCE_TITLE: 'Adquirir um seguro',
		PURCHASE_INSURANCE_TEXT:
			'Inicie o processo de adquirir seu seguro de forma rápida e fácil.',
		AVAILABLE_QUOTES_TITLE: 'Ver cotações disponíveis',
		AVAILABLE_QUOTES_TEXT: 'Confira as cotações disponíveis na Latú!',
		AVAILABLE_QUOTES_UNAVAILABLE_TEXT:
			'Em breve você terá acesso às cotações do seu seguro.',
		AVAILABLE_POLICY_TITLE: 'Ver apólices disponíveis',
		AVAILABLE_POLICY_TEXT: 'Confira suas apólices e status de pagamento.',
		AVAILABLE_POLICY_UNAVAILABLE_TEXT:
			'Você poderá ver suas apólices assim que seu seguro estiver ativo.',
		VIEW_QUOTES_TEXT: 'Ver cotações',
		VIEW_POLICY_TEXT: 'Ver apólices',
		ACTIVE_TAG_POLICY_COPY: 'Vigência ativa',
		CREATED_TAG_POLICY_COPY: 'Ativação em {{startDate}}',
		EXPIRED_TAG_POLICY_COPY: 'Vigência Expirada',
		PENDING_PAYMENT_TAG_POLICY: 'Ativação Pendente de pagamento inicial',
		FORM_ADD_COMPANY_TITLE: 'Adicionar empresa',
		CLAIMS_DETAIL_TITLE_PAGE: 'Sinistro',
		CLAIMS_PAGE_MENU: 'Reclamações',
		CLAIMS_TITLE_PAGE: 'Sinistros',
		CLAIMS_SUBTITLE_PAGE:
			'Visualize os sinistros que você tem em aberto e acompanhe o status de cada um.',
		CLAIMS_CTA_TITLE: 'Comunicar um sinistro.',
		CLAIMS_CTA_SUBTITLE:
			'Preencha os dados do sinistro para que possamos te ajudar.',
		CLAIMS_TABLE_TITLE: 'Sinistros por status',
		CLAIMS_TABLE_SUBTITLE: 'Acompanhe os status de seus sinistros comunicados.',
		CLAIMS_TABLE_PROTOCOL: 'Nº de protocolo',
		CLAIMS_TABLE_TYPE: 'Tipo do sinistro.',
		CLAIMS_TABLE_UPDATE: 'Última atualização',
		CLAIMS_TABLE_DOWNLOAD: 'Ver sinistro',
		CLAIMS_CREATE_TITLE: 'Comunicar sinistro.',
		CLAIMS_CREATE_SUBTITLE: 'Por favor, preencha as informações abaixo:',
		CLAIMS_CREATE_Mandatory: 'Preenchimento obrigatório',
		CLAIMS_CREATE_TYPE: 'Selecione o seguro que deseja comunicar o sinistro:',
		CLAIMS_CREATE_SELECT: 'Selecione',
		CLAIMS_CREATE_SHORT_DESCRIPTION: 'Descrição do ocorrido:',
		CLAIMS_CREATE_CONTACT_NAME: 'Nome completo:',
		CLAIMS_CREATE_CONTACT_NAME_TEXT: 'Digite seu nome completo:',
		CLAIMS_CREATE_CONTACT_EMAIL: 'E-mail:',
		CLAIMS_CREATE_CONTACT_EMAIL_TEXT: 'Digite um e-mail válido:',
		CLAIMS_CREATE_CONTACT_TELEPHONE: 'Nos informe seu número para contato:',
		CLAIMS_CREATE_CONTACT_TELEPHONE_TEXT: 'Insira seu número de celular:',
		CLAIMS_CREATE_CTA: 'Abrir sinistro',
		CLAIMS_DATA_ZERO_TEXT:
			'Não encontramos um seguro ativo associado à sua conta no momento. Assim que você adquirir um seguro conosco, estaremos prontos para ajudar no caso de qualquer sinistro.',
		CLAIMS_STATUS_PENDING: 'Em andamento',
		CLAIMS_STATUS_IN_PROGRESS: 'Em andamento',
		CLAIMS_STATUS_REJECTED: 'Encerrada',
		CLAIMS_STATUS_APPROVED: 'Aprovada',
		CLAIMS_DETAILS_SUB_TITLE: 'Detalhes do sinistro',
		CLAIMS_DETAIL_FULL_NAME: 'Nome completo',
		CLAIMS_DETAIL_PHONE_CONTACT: 'Telefone de contato',
		CLAIMS_DETAIL_EMAIL: 'Email',
		CLAIMS_DESCRIPTION_INCIDENT: 'Descrição do ocorrido',
		CLAIMS_DESCRIPTION_UPDATES_SUBTITLE: 'Atualizações',
		SUCCESS_SCREEN_TITLE: 'Seu sinistro foi comunicado.',
		SUCCESS_SCREEN_SUBTITLE:
			'Recebemos sua solicitação. Aguarde enquanto analisamos, iremos retornar o mais breve possível.',
		SUCCESS_SCREEN_PRODUCT_TITLE: 'Produto',
		SUCCESS_SCREEN_SUMMARY: 'Resumo do sinistro',
		SUCCESS_SCREEN_VIEW_CLAIM: 'Visualizar sinistro',
		SUCCESS_SCREEN_GO_BACK: 'Ir para página inicial',
		FOOTER_SUPPORT: 'Suporte',
		FOOTER_SCHEDULE_INFO: 'Agendar uma reunião',
		TOOLTIP_TITLE_SUBLIMITS: 'Sobre o sublimite',
		TOOLTIP_INFO_SUBLIMITS:
			'Limite máximo dentro da apólice de seguro para coberturas específicas.',
		TOOLTIP_INFO_FRANQUIA:
			'Representa a quantia de dinheiro que o segurado deve pagar do próprio bolso antes que sua cobertura de seguro entre em vigor.',
		BUBBLE_WHATSAPP_INFO: 'Contacte-nos via WhatsApp',
		BUBBLE_SCHEDULE_MEET_INFO: 'Agendar uma reunião',
		USER_DISABLED: 'Ativo',
		USER_ENABLED: 'Inativo',
		USER_PENDING: 'Pendente',
		ROL_COPY_ADMIN: 'Administrador',
		ROL_COPY_BROKER: 'Administrador',
		ROL_COPY_BROKER_INVITED: 'Membro do time',
		ROL_COPY_BROKER_CUSTOMER: 'Administrador',
		ROL_COPY_USER: 'Membro do time',
		REQUIRED_NAME: 'O nome é obrigatório',
		REQUIRED_EMAIL: 'O e-mail é obrigatório',
		INVALID_EMAIL: 'O formato do e-mail é inválido',
		MENU_NAME: 'Membros de equipe',
		ROLES_TITLE: 'Membros de equipe',
		ROLES_SUBTITLE:
			'Convide ou gerencie os companheiros de trabalho da sua equipe',
		ROLES_MAIN_CTA: 'Convidar membros',
		ACCOUNT_OWNERSHIP: 'Administrador da conta',
		ACCOUNT_OWNERSHIP_DISCLAIMER_1: 'Para alterar o',
		ACCOUNT_OWNERSHIP_DISCLAIMER_2: 'administrador,',
		ACCOUNT_OWNERSHIP_DISCLAIMER_3: 'entre em contato com o suporte',
		PENDING_INVITATIONS_COPY: 'Convites pendentes',
		USER_NAMES: 'Nome completo',
		USER_EMAIL: 'E-mail',
		USER_ROLE: 'Permissões',
		USER_ACTIONS: 'Ação possível',
		RE_SEND_INVITATION_BUTTON: 'Reenviar convite',
		ADMIN_ROLE: 'Administrador',
		TEAM_MEMBER_ROLE: 'Membro do time',
		REMOVE_USER_TITLE:
			'Você tem certeza que deseja remover este membro de equipe?',
		REMOVE_USER_SUBTITLE_1: 'O usuário',
		REMOVE_USER_INVITE_SUBTITLE_1: 'O convidado com o endereço de e-mail',
		REMOVE_USER_SUBTITLE_2:
			'não terá mais acesso à conta da Latú. porém você poderá adicionar o usuário novamente quando quiser',
		REMOVE_USER_INVITE_SUBTITLE_2:
			'não terá mais um convite pendente para a conta da Latú. Não se preocupe, você pode enviar um novo convite quando quiser.',
		REMOVE_USER_QUESTION: 'Deseja remover o usuário?',
		REMOVE_USER_INVITE_QUESTION: 'Você quer remover este convidado?',
		REMOVE_USER_CONFIRM: 'Remover usuário',
		REMOVE_USER_CANCEL: 'Cancelar',
		REMOVE_USER_SUCCESS_1: 'O usuário',
		REMOVE_USER_SUCCESS_2: 'foi removido com sucesso!',
		ADD_VIEW_TITLE: 'Convidar membros de equipe',
		ADD_VIEW_SUBTITLE:
			'Escolha um ou mais membros para compor o seu time através de nome e email.',
		ADD_VIEW_SUCCESS_TITLE: 'Membros convidados com sucesso!',
		ADD_VIEW_SUCCESS_SUBTITLE:
			'Enviaremos um email a todos os membros adicionados para que possam ter acesso imediato à plataforma da Latú Corretores',
		ADD_VIEW_SUCCESS_SUBTITLE_TO_USER:
			'Enviaremos um email a todos os membros adicionados para que possam ter acesso imediato à plataforma da Latú Seguros',
		ADD_VIEW_NAME_TITLE: 'Nome',
		ADD_VIEW_NAME_PLACEHOLDER: 'Digite um nome válido',
		ADD_VIEW_TEAM_EMAIL: 'email',
		ADD_VIEW_EMAIL_TITLE: 'Email',
		ADD_VIEW_EMAIL_PLACEHOLDER: 'Digite um e-mail válido',
		ADD_VIEW_EMAIL_ROLE: 'Membro do time',
		ADD_VIEW_ADD_MORE: 'Adicionar membro',
		ADD_VIEW_CONFIRM_CTA: 'Convidar membro',
		ADD_VIEW_CONFIRM_CTA_MANY: 'Convidar {{numMembers}} membros',
		ADD_VIEW_CANCEL: 'Cancelar',
		ADD_VIEW_SUCCESS_CTA: 'Entendido',
		ADD_VIEW_SUCCESS_MESSAGE: 'Convite enviado com sucesso',
		ADD_VIEW_BACK_BUTTON: 'Voltar',
		ADD_VIEW_NO_ACCESS:
			'Desculpe - Seu nível de acesso atual não permite que você convide pessoas.',
		REGISTER_SCREEN_TITLE: 'Bem-vindo à Latú!',
		REGISTER_SCREEN_SUBTITLE: 'Insira seus dados para criar uma conta',
		REGISTER_SCREEN_ACCOUNT_INFO_TITLE: 'Dados da conta',
		REGISTER_SCREEN_ACCOUNT_INFO_EMAIL: 'Endereço de e-mail',
		REGISTER_SCREEN_ACCOUNT_INFO_COMPANY: 'Equipe/Organização',
		REGISTER_SCREEN_ACCOUNT_INFO_GOOGLE_LOGIN: 'Continuar com o Google',
		REGISTER_SCREEN_ACCOUNT_OPTION_TEXT: 'ou faça login com e-mail',
		REGISTER_SCREEN_ACCOUNT_USERNAME: 'Nome completo',
		REGISTER_SCREEN_ACCOUNT_USERNAME_PLACEHOLDER: 'Digite seu nome completo',
		REGISTER_SCREEN_ACCOUNT_PASSWORD: 'Crie sua senha',
		REGISTER_SCREEN_ACCOUNT_PASSWORD_PLACEHOLDER: 'Digite sua senha',
		REGISTER_SCREEN_ACCOUNT_TERMS_CONDITIONS: 'Aceito os Termos de Serviço',
		REGISTER_SCREEN_ACCOUNT_CTA: 'Registrar',
		WELCOME_SCREEN_TITLE: 'Bem-vindo ao App da Latú!',
		WELCOME_SCREEN_SUBTITLE:
			'Dentro deste hub, você poderá visualizar suas apólices de negócios, navegar por cotações e lidar com reclamações. É o seu destino único para tudo relacionado a seguros, colocando você no controle como nunca antes.',
		WELCOME_SCREEN_CTA: 'Entendi',
		BANNER_PROGRESS_RENEWAL_IPAF_TITLE:
			'Você possui apólices prestes a vencer!',
		BANNER_PROGRESS_RENEWAL_IPAF_TEXT:
			'Renove suas apólices e mantenha sua empresa segura.',
		BANNER_PROGRESS_RENEWAL_IPAF_CALL_TO_ACTION: 'Renovar apólice',
		INFO_PERCENT_DEDUCTIBLE: 'dos prejuízos',
		INFO_NO_DEDUCTIBLE: 'Seguro sem franquia',
		INFO_NO_DEDUCTIBLE_TEMP:
			'10% dos prejuízos, com um mínimo de R$ 250.000,00',
		FRANQUIA_TITLE: 'Franquia (aplica-se a qualquer sinistro)',
		FRANQUIA_DEFINITION:
			'Quantia para pagamento antes que a cobertura seja fornecida.',
		MINIMUM_OF: 'Mínimo de',
		REGULATORY_DISCLAIMER:
			'Para uma descrição e lista completa das coberturas, exclusões e definições gerais, favor referir-se às Condições Gerais do Produto.',
		REGULATORY_DISCLAIMER_LINK: 'Baixar condições gerais.',
		INTRODUCTION_RENEWALS_MANTRA_A: 'Bem-vindo ao processo de',
		INTRODUCTION_RENEWALS_MANTRA_B: 'renovação',
		INTRODUCTION_RENEWALS_MANTRA_C: 'do seu seguro.',
		INTRODUCTION_RENEWALS_TITLE_A: 'Para renovar seus seguros, precisamos',
		INTRODUCTION_RENEWALS_TITLE_B: 'atualizar seus dados.',
		INTRODUCTION_RENEWALS_TITLE_C: 'Não se preocupe, o',
		INTRODUCTION_RENEWALS_TITLE_D:
			'processo de coleta de informações é totalmente simplificado!',
		INTRODUCTION_RENEWALS_SUBTITLE_PRODUCTS: 'Seguros em período de renovação:',
		INTRODUCTION_RENEWALS_SLIDER_TITLE:
			'Como funciona o processo de renovação?',
		INTRODUCTION_RENEWALS_SLIDER_STEP1_TITLE:
			'Simplificando o processo para você:',
		INTRODUCTION_RENEWALS_SLIDER_STEP1_TEXT:
			'Atualizamos o aplicativo para simplificar o fornecimento de informações, com a maioria dos detalhes já pré-preenchidos. Nossa equipe usará essas informações para propor a melhor renovação para o seu negócio.',
		INTRODUCTION_RENEWALS_SLIDER_STEP2_TITLE:
			'Análise das novas informações e apresentação de proposta.',
		INTRODUCTION_RENEWALS_SLIDER_STEP2_TEXT:
			'Apresentamos uma proposta totalmente adaptada, incluindo coberturas, limites, condições e prêmios. Ao escolher a proposta ideal, começaremos a emitir a apólice e os documentos de pagamento. Ficaremos à disposição para esclarecer e assegurar sua total compreensão da proposta.',
		INTRODUCTION_RENEWALS_SLIDER_STEP3_TITLE: 'Apólice renovada!',
		INTRODUCTION_RENEWALS_SLIDER_STEP3_TEXT:
			'Após a conclusão de todos os procedimentos, você poderá acessar a sua apólice atualizada diretamente através do aplicativo.',
		INTRODUCTION_RENEWALS_REMINDER_TEXT_A: 'Lembrete:',
		INTRODUCTION_RENEWALS_REMINDER_TEXT_B:
			'Antes que qualquer uma de suas apólices atuais expire, nossa equipe irá lhe comunicar.',
		INTRODUCTION_RENEWALS_START_BUTTON: 'Iniciar renovação',
		REVIEW_ANSWER_TITLE:
			'Revise suas informações abaixo e criaremos sua cotação.',
		REVIEW_ANSWER_QUESTION: 'Pergunta',
		REVIEW_ANSWER_ANSWER: 'Resposta',
		REVIEW_ANSWER_EDIT: 'Editar',
		REVIEW_ANSWER_CONTINUE: 'Avançar',
		NO_FILE_ANSWER: 'Nenhum documento foi anexado.',
		CYBER_MODULE_TIERS_LITE: 'Latú Cyber Lite',
		CYBER_MODULE_TIERS_PLUS: 'Latú Cyber Plus',
		CYBER_MODULE_SUBSCRIBE_INTRO_TITLE: 'Latú Scan',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_1:
			'Assuma o controle da sua segurança cibernética com a Latú Scan, a principal ferramenta de gestão de riscos adotada por organizações de todos os tamanhos. Obtenha visibilidade dos seus ativos, identifique vulnerabilidades antes de possíveis ataques e saiba como corrigi-las.',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_2:
			'controle da sua segurança cibernética',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_3: 'com a',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_4: 'Latú Sonar,',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_5:
			'a principal ferramenta de gestão de riscos adotada por organizações de todos os tamanhos. Obtenha',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_6: 'visibilidade dos seus ativos,',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_7: 'identifique',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_8: 'vulnerabilidades',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_9:
			'antes de possíveis ataques e saiba como',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_10: 'corrigi-las.',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_11:
			'Solicite a sua primeira avaliação agora!',
		CYBER_MODULE_SUBSCRIBE_INTRO_TEXT_12: 'Solicitar avaliação',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_TITLE: 'O que analisamos?',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_1:
			'Ativos de dados (como domínios, IPs e todas as 65 mil portas)',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_2: 'Aplicativos e Serviços',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_3: 'Vazamentos de dados',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_LIST_4: 'Riscos de phishing',
		CYBER_MODULE_SUBSCRIBE_INTRO_BANNER_BUTTON:
			'Assista ao vídeo de segurança cibernética.',
		CYBER_MODULE_SUBSCRIBE_FORM_TITLE: 'Solicitar Avaliação Cibernética.',
		CYBER_MODULE_SUBSCRIBE_FORM_SUBTITLE:
			'Precisamos apenas de alguns dados para realizar a avaliação ajustada para o seu negócio.',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN: 'Domínio principal',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN_DESCRIPTION_1: 'Nota:',
		CYBER_MODULE_SUBSCRIBE_FORM_DOMAIN_DESCRIPTION_2:
			'iremos buscar todos os subdomínios e endereços IP atrelados ao domínio listado para a análise cibernética.',
		CYBER_MODULE_SUBSCRIBE_FORM_ACTIVITY: 'Atividade da empresa.',
		CYBER_MODULE_SUBSCRIBE_FORM_COMPANY_SIZE: 'Número de funcionários.',
		CYBER_MODULE_SUBSCRIBE_FORM_COMPANY_REVENUE: 'Receita do último ano.',
		CYBER_MODULE_SUBSCRIBE_FORM_BUTTON: 'Solicitar avaliação.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_TITLE:
			'Solicitação realizada com sucesso.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_TEXT:
			'Vamos notificar o andamento de sua Análise Cibernética pelo e-mail',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BUTTON_REPORTS:
			'Ir para meus relatórios.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BANNER_TITLE:
			'Agora você pode contratar o Seguro Cyber da Latú.',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BANNER_SUBTITLE:
			'Você evoluiu em direção à conformidade. Conheça o nosso seguro Cyber e dê mais um passo em direção a segurança cibernética de sua empresa!',
		CYBER_MODULE_SUBSCRIBE_SUCCESS_SCREEN_BUTTON_QUOTE: 'Faça sua cotação.',
		CYBER_MODULE_TALK_TO_LATU: 'Falar com a Latú',
		CYBER_MODULE_TIERS_DETAIL_TITLE:
			'Faça um upgrade na sua segurança cibernética!',
		CYBER_MODULE_TIERS_DETAIL_SUBTITLE: 'Confira abaixo os planos disponíveis:',
		CYBER_MODULE_TIERS_DETAIL_LITE_TAG: 'Pacote Atual',
		CYBER_MODULE_TIERS_DETAIL_LITE_TITLE: 'Latú Cyber Lite',
		CYBER_MODULE_TIERS_DETAIL_LITE_SUBTITLE:
			'Proteção essencial para a sua presença digital.',
		CYBER_MODULE_TIERS_DETAIL_LITE_PRICE_TEXT:
			'Valor válido por tempo limitado!',
		CYBER_MODULE_TIERS_DETAIL_LITE_PERKS_1:
			'Avaliação de vulnerabilidade trimestral',
		CYBER_MODULE_TIERS_DETAIL_LITE_PERKS_2:
			'Checklist de Conformidade para Cibersegurança e LGPD',
		CYBER_MODULE_TIERS_DETAIL_PLUS_TAG: 'Recomendado',
		CYBER_MODULE_TIERS_DETAIL_PLUS_TITLE: 'Latú Cyber Plus',
		CYBER_MODULE_TIERS_DETAIL_PLUS_SUBTITLE:
			'Segurança total e orientação especializada.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_BUTTON_QUOTE: 'Faça uma cotação',
		CYBER_MODULE_TIERS_DETAIL_PLUS_BUTTON_BOOK:
			'O valor desse plano é personalizado.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_1:
			'Tudo o que está incluído no plano Lite.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_2: 'Proteção de Seguro Cibernético.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_3:
			'Avaliação de vulnerabilidade mensal.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_4: 'Simulação e Teste de Phishing.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_5:
			'Acesso a especialistas em Ciber-segurança.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_6:
			'Gestão de resposta a incidentes, 24/7.',
		CYBER_MODULE_TIERS_DETAIL_PLUS_PERKS_7:
			'Firewall, Antivírus e Backup de Dados inclusos gratuitamente.',
		CYBER_MODULE_CONTACT_BANNER_TITLE: 'Como deseja contatar nossa equipe?',
		CYBER_MODULE_CONTACT_BANNER_SUBTITLE:
			'Estamos aqui para ajudar! Escolha a melhor forma de contato:',
		CYBER_MODULE_REPORT_TITLE: 'Avaliação Cibernética.',
		CYBER_MODULE_REPORT_SUBTITLE: 'Histórico de avaliações cibernéticas',
		CYBER_MODULE_REPORT_TEXT_1:
			'Acesse os relatórios realizados através das avaliações realizadas pela',
		CYBER_MODULE_REPORT_TEXT_2: 'Latú Sonar.',
		CYBER_MODULE_REPORT_BANNER_TITLE: 'Recursos analisados.',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_1: 'Você possui uma',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_2: 'avaliação em andamento.',
		CYBER_MODULE_REPORT_BANNER_SUBTITLE_3:
			'Em breve, você poderá visualizar os recursos analisados.',
		CYBER_MODULE_REPORT_COLUMN_DATE: 'Data do relatório.',
		CYBER_MODULE_REPORT_COLUMN_SCORE: 'Pontuação da empresa.',
		CYBER_MODULE_REPORT_COLUMN_VULNERABILITIES: 'Número de vulnerabilidades.',
		CYBER_MODULE_REPORT_COLUMN_DISCLAIMER:
			'Caso deseje cancelar suas avaliações periódicas, entre em contato conosco.',
		CYBER_MODULE_REPORT_COLUMN_RISK_LOW: 'Baixo risco',
		CYBER_MODULE_REPORT_COLUMN_RISK_MEDIUM: 'Risco médio',
		CYBER_MODULE_REPORT_COLUMN_RISK_HIGH: 'Alto risco',
		CYBER_MODULE_REPORT_COLUMN_VULNERABILITIES_LABEL: 'vulnerabilidades',
		CYBER_MODULE_REPORT_COLUMN_UNDER_REVIEW: 'Em análise',
		CYBER_PAGE_MENU: 'Avaliação Cibernética',
		ANNUAL_REVENUE_OPTION_1: 'Menos de R$ 250.000',
		ANNUAL_REVENUE_OPTION_2: '250.000 - R$ 1.000.000',
		ANNUAL_REVENUE_OPTION_3: 'R$ 1.000.000 - R$ 5.000.000',
		ANNUAL_REVENUE_OPTION_4: 'Mais de R$ 5.000.000',
		COMPANY_ACTIVITY_OPTION_1: 'Saúde',
		COMPANY_ACTIVITY_OPTION_2: 'Serviços Financeiros',
		COMPANY_ACTIVITY_OPTION_3: 'Manufatura',
		COMPANY_ACTIVITY_OPTION_4: 'Outros',
		CAPITAL_RAISED: 'Capital Levantado',
		FINANCING_OBTAINED: 'Financiamento Obtido',
		ADDITIONAL_INSTRUCTIONS_SECTION_TITLE: 'Instruções adicionais',
		ADDITIONAL_INSTRUCTIONS_SECTION_SUBTITLE:
			'Caso tenha instruções adicionais, utilize o campo abaixo:',
		ADDITIONAL_INSTRUCTIONS_SECTION_PLACEHOLDER: 'Escreva aqui.',
		ADDITIONAL_INSTRUCTIONS_SECTION_BUTTON: 'Finalizar',
		ADDITIONAL_INSTRUCTIONS_MODAL_TITLE: 'Informações sobre seu orçamento!',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_1: 'Notamos que você adicionou',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_2: 'instruções adicionais',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_3:
			'no pedido de seguro. No entanto, você é elegível para receber um orçamento automatizado. Por favor,',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_4: 'revise o orçamento fornecido;',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_5:
			'caso ele não atenda às suas instruções específicas, não se preocupe,',
		ADDITIONAL_INSTRUCTIONS_MODAL_SUBTITLE_6:
			'nossa equipe entrará em contato com você em breve.',
		ADDITIONAL_INSTRUCTIONS_MODAL_BUTTON: 'Ok, entendi',
		NDA_CTA: ' Clique aqui para baixar nosso NDA.',
		USER_TYPE_SELECTION_PAGE_TOOLTIP:
			'Você terá a conveniência de concluir todo o processo de forma online, contando com a assistência dedicada de um dos nossos corretores parceiros, que será designado para oferecer qualquer suporte necessário. A Latú também estará disponível para ajudar em nome da seguradora, mas sempre trabalhamos em conjunto com corretores.',
		TAX_ID_FIELD_TOOLTIP_INFO: 'Os campos ativos podem ser editados.',
		TAX_ID_FIELD_COMPANY_NAME_LABEL: 'Nome da Empresa:',
		TAX_ID_FIELD_COMPANY_CREATION_DATE_LABEL:
			'Quando a empresa iniciou suas operações?',
		TAX_ID_FIELD_COMPANY_ADDRESS_TITLE: 'Endereço da empresa',
		TAX_ID_FIELD_COMPANY_ADDRESS_STREET_LABEL: 'Rua',
		TAX_ID_FIELD_COMPANY_ADDRESS_CITY_LABEL: 'Cidade',
		TAX_ID_FIELD_COMPANY_ADDRESS_NUMBER_LABEL: 'Número',
		TAX_ID_FIELD_COMPANY_ADDRESS_STATE_LABEL: 'Estado',
		TAX_ID_FIELD_COMPANY_ADDRESS_DETAIL_LABEL: 'Complemento',
		TAX_ID_FIELD_COMPANY_ADDRESS_ZIP_CODE_LABEL: 'CEP',
		TAX_ID_FIELD_COMPANY_ADDRESS_NEIGHBORHOOD_LABEL: 'Bairro',
		BROKER_POLICY_ISSUED: 'Visualizar apólice',
		BROKER_IPAF_IN_PROGRESS: 'Formulário em andamento',
		BROKER_IPAF_EXPIRED: 'Formulário expirado',
		BROKER_QUOTING_IN_PROGRESS: 'Trabalhando em cotação',
		BROKER_QUOTE_AWAITING_SELECTION: 'Cotação pendente de seleção',
		BROKER_QUOTE_EXPIRED: 'Cotação expirou',
		BROKER_QUOTE_REJECTED: 'Cotação não foi aceita',
		BROKER_REJECTED: 'Cotação não foi aceita',
		BROKER_ISSUING_POLICY: 'Elaborando a apólice',
		BROKER_POLICY_EXPIRED: 'Apólice vencida',
		BROKER_POLICY_PENDING_PAYMENT: 'Pagamento do seguro pendente',
		BROKER_POLICY_TO_RENEW: 'Renove a apólice',
		BROKER_POLICY_PENDING_SIGNATURE: 'Assinatura pendente',
		BROKER_MONTH_SLIDER_RECEIVED: 'NF recebida',
		BROKER_MONTH_SLIDER_PENDING: 'NF pendente',
		BROKER_MONTH_SLIDER_OPEN: 'Em aberto',
		BROKER_MOVEMENT_DELAYED: 'Atrasado',
		BROKER_MOVEMENT_PAID: 'Pago',
		BROKER_MOVEMENT_PENDING: 'Aguardando',
		BROKER_FISCAL_NOTE_APPROVED: 'Aprovado',
		BROKER_FISCAL_NOTE_PENDING: 'NF pendente',
		BROKER_FISCAL_NOTE_WAITING_APPROVAL: 'Em revisão',
		BROKER_FISCAL_NOTE_NEED_ACTION: 'NF pendente',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_TITLE:
			'Pronto para finalizar seu questionário?',
		ONE_PAGE_IPAF_MODAL_ONE_ACTION: 'Finalizar questionário',
		ONE_PAGE_IPAF_MODAL_SECOND_ACTION: 'Revisar dados',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_SUBTITLE:
			'Revise cuidadosamente suas respostas agora para evitar futuros atrasos no processo de cotação.',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_BUTTON: 'Confirmar e Prosseguir',
		ONE_PAGE_IPAF_MODAL_CONFIRMATION_CANCEL: 'Revisar os Dados',
		ONE_PAGE_FINISH: 'Finalizar',
		ONE_PAGE_NEXT: 'Salvar e continuar',
		SHARE_IPAF_BUTTON: 'Compartilhar',
		ONE_PAGE_ANSWERS_PENDING_INFO:
			'Há perguntas pendentes que precisam ser respondidas antes de podermos fornecer um orçamento de seguro para a sua empresa. Por favor, responda-as antes de prosseguir.',
		DATA_CAPITAL_RAISED_A: 'Capital Levantado',
		DATA_CAPITAL_RAISED_B: 'Dívida Levantada',
		PENDING_PAYMENT_BANNER_TITLE:
			'Não esqueça de realizar o pagamento do seu seguro!',
		PENDING_PAYMENT_BANNER_INFO:
			'Sua apólice estará ativa apenas após o pagamento da primeira parcela.',
		PAY_NOW: 'Pagar a fatura atual.',
		INVALID_TAX_ID: 'Identificação fiscal inválida',
		EMPLOYS_TAG_FULL_TIME: 'Tempo Integral (CLT)',
		EMPLOYS_TAG_HALF_TIME: 'Meio Período',
		EMPLOYS_TAG_THIRD_TIME: 'Tercerizado (PJ)',
		COMPANY_SHAREHOLDER_ADD_BUTTON_TEXT: 'Adicionar clientes',
		SHAREHOLDER_NAME_LABEL: 'Nome do acionista',
		SHAREHOLDER_NAME_PLACEHOLDER: 'Nome de cliente',
		SHAREHOLDER_PERCENTAGE_LABEL: '% de distribuição',
		SHAREHOLDER_BUTTON_TO_ADD: 'Adicionar mais um',
		SHAREHOLDER_BUTTON_TO_SAVE: 'Salvar dados',
		COMPANY_SHAREHOLDER_EDIT_TEXT: 'Editar',
		INDICATE_BILLING_PERCENTAGE_BUTTON: 'Indicar percentual de faturamento',
		INDICATE_INDUSTRY_CUSTOMERS: 'Indicar as atividades de seus clientes',
		LIST_ACTIVITY_DATA_PROCESSING: 'Processamento de Dados',
		LIST_ACTIVITY_SOFTWARE_DEVELOPMENT_INTERNAL:
			'Desenvolvimento de Software (específico)',
		LIST_ACTIVITY_SOFTWARE_DEVELOPMENT_EXTERNAL:
			'Desenvolvimento de Software (Pacote)',
		LIST_ACTIVITY_CONSULTING_PLANNING: 'Consultoria / Planejamento',
		LIST_ACTIVITY_SYSTEM_INSTALLATION_MAINTENANCE:
			'Instalação / Manutenção de Sistemas',
		LIST_ACTIVITY_WEBSITE_DEVELOPMENT_DESIGN_MAINTENANCE:
			'Desenvolvimento, design e manutenção de sites',
		LIST_ACTIVITY_WEB_HOSTING: 'Web Hosting',
		LIST_ACTIVITY_E_COMMERCE: 'E - Commerce',
		LIST_ACTIVITY_TRAINING_EDUCATIONAL_SERVICES:
			'Treinamento / Serviços educacionais',
		LIST_ACTIVITY_PAYMENT_PROCESSING: 'Processamento de pagamentos',
		LIST_ACTIVITY_HARDWARE_DEVELOPMENT: 'Desenvolvimento de Hardware',
		LIST_ACTIVITY_HARDWARE_MAINTENANCE: 'Manutenção de de Hardware',
		LIST_ACTIVITY_OTHERS: 'Outros',
		BUTTON_SAVE_ACTIVITIES: 'Salvar dados',
		COPY_ERROR_SUM_MUST_BE_100: 'A soma não pode exceder 100%',
		LIST_ROLES_FOUNDER: 'Founder',
		LIST_ROLES_C_LEVEL_EXECUTIVE: 'C level',
		LIST_ROLES_DIRECTOR: 'Diretor',
		LIST_ROLES_MANAGER: 'Gerente',
		LIST_ROLES_SPECIALIST_ANALYST: 'Especialista / analista',
		LIST_ROLES_OTHER: 'Outro',
		LIST_DEGREES_MASTERS: 'Mestrado',
		LIST_DEGREES_HIGHER_EDUCATION_COMPLETED: 'Ensino superior completo',
		LIST_DEGREES_HIGH_SCHOOL: 'Ensino Médio completo',
		LIST_DEGREES_TECHNICAL_COURSE: 'Curso Técnico',
		LIST_DEGREES_OTHER: 'Outro',
		REVENUE_SECTION_TITLE_1: 'Nome completo',
		REVENUE_SECTION_PLACEHOLDER_1: 'Digite o nome completo',
		REVENUE_SECTION_TITLE_2: 'Cargo',
		REVENUE_SECTION_PLACEHOLDER_2: 'Selecione o cargo',
		REVENUE_SECTION_TITLE_3: 'Formação acadêmica',
		REVENUE_SECTION_PLACEHOLDER_3: 'Selecione a formação acadêmica',
		REVENUE_BUTTON_ADD: 'Adicionar mais um',
		REVENUE_BUTTON_SAVE: 'Salvar dados',
		REVENUE_SECTION_ERROR_1: 'O campo nome é obrigatório',
		REVENUE_SECTION_ERROR_2: 'O campo cargo é obrigatório',
		REVENUE_SECTION_ERROR_3: 'O campo formação acadêmica é obrigatório',
		EDUCATION_LABEL: 'Formação',
		COMPANY_STRUCTURE_DOCUMENT_LABEL: 'Identificación',
		COMPANY_STRUCTURE_OPERATIONAL_LABEL: 'Operacional',
		SELECTED_LABEL: 'Selecionado',
		REGISTER_CHILD_USER_PLACEHOLDER_FIRST_NAME: 'Nome',
		REGISTER_CHILD_USER_PLACEHOLDER_LAST_NAME: 'Sobrenome',
		ERROR_AUTH_PAGE_TITLE: 'Ops, um erro foi encontrado!',
		ERROR_AUTH_PAGE_INTRO:
			'Encontramos um problema ao criar a sua conta. Nossa equipe entrará em contato com você em breve com todas as informações necessárias para a sua conta.',
		RESTORE_PASSWORD_PAGE_TITLE:
			'Ação necessária: Por favor, redefina sua senha',
		RESTORE_PASSWORD_PAGE_INTRO:
			'Para aumentar a segurança, estamos migrando nosso sistema de autenticação. Como resultado, será necessário redefinir sua senha. Esta mudança faz parte de nossos esforços contínuos para aprimorar a segurança da sua conta e proteger seus dados.',
		RESTORE_PASSWORD_PAGE_SUBTITLE: 'O que você pode esperar?',
		RESTORE_PASSWORD_PAGE_DESCRIPTION_1:
			'Transição tranquila: Estamos trabalhando para garantir que a transição seja o mais tranquila possível, com interrupções mínimas no seu serviço.',
		RESTORE_PASSWORD_PAGE_DESCRIPTION_2:
			'Segurança aprimorada: Redefinir sua senha ajudará a manter sua conta segura.',
		RESTORE_PASSWORD_PAGE_BUTTON: 'Reiniciar senha',
		INSURANCE_CERTIFICATE_BUTTON: 'Declaração de Seguros',
		SHARE_CERTIFY_TITLE: 'Compartilhar Declaração',
		SHARE_CERTIFY_DESCRIPTION:
			'Latú vai gerar um documento para você compartilhar com seus clientes, fornecedores ou interessados. Selecione as apólices para as quais deseja criar a declaração.',
		SHARE_CERTIFY_DOWNLOAD: 'Baixar',
		SHARE_CERTIFY_BUTTON: 'Enviar e-mail',
		INPUT_EMAIL_PLACEHOLDER: 'seucliente@empresa.com',
		INPUT_EMAILS_LIST_PLACEHOLDER:
			'Digite um ou mais endereços de e-mail, separados por vírgulas.',
		ERROR_LIST_EMAIL_INVALID:
			'O formato de alguns emails está incorreto e o correio não pôde ser enviado.',
		CERTIFY_SHARED_SUCCESS: 'Declaração compartilhado com sucesso',
		BILLING_USER_SECTION_TITLE: 'Email de faturamento',
		BILLING_USER_SECTION_DETAIL:
			'Este é o endereço de e-mail que usaremos para enviar suas faturas e informações de pagamento. Se o e-mail não estiver registrado, apenas o titular da apólice receberá os e-mails de pagamento.',
		BILLING_USER_PLACE_HOLDER: 'email@empresa.com',
		BILLING_USER_SECTION_EDIT_CTA: 'Editar email',
		BILLING_USER_SECTION_ADD_CTA: 'Adicionar email',
		BILLING_EDIT_TITLE: 'Insira o seu novo email de faturamento:',
		BILLING_MODAL_EDIT_CTA: 'Atualizar e-mail',
		BILLING_CANCEL_CTA: 'Cancelar',
		BILLING_ADD_EMAIL_SUCCESS: 'Email de faturamento atualizado!',
		BILLING_ADD_EMAIL_SUCCESS_SUBTITLE:
			'A partir de agora, você receberá tudo relacionado à sua fatura e informações de pagamento neste novo e-mail:',
		BILLING_ADD_EMAIL_SUCCESS_CTA: 'Entendido',
		NOT_FOUND_ACCOUNT_TITLE_1: 'Seu e-mail',
		NOT_FOUND_ACCOUNT_TITLE_2:
			'não está associado a uma conta da Latú Seguros.',
		NOT_FOUND_ACCOUNT_INTRO_1:
			'Se sua empresa já é cliente, solicite ao seu administrador que conceda acesso à sua conta corporativa.',
		NOT_FOUND_ACCOUNT_INTRO_2:
			'Se ainda não é cliente da Latú Seguros, descubra como proteger sua empresa de forma eficaz e confiável.',
		NOT_FOUND_ACCOUNT_BUTTON: 'Crie sua conta',
		INVITE_SUCCESS_RE_SEND_INFO: 'O convite foi reenviado com sucesso.',
		SEND_PAYMENT_VOUCHER_BUTTON: 'Envie o boleto de pagamento ao seu cliente!',
		INFO_IPAF_QUESTION_PENDING_TO_FILL: 'Ainda há perguntas sem resposta.',
		MOBILE_IPAF_INFO_TITLE: 'Preenchimento otimizado para versão web!',
		MOBILE_IPAF_INFO_TEXT:
			'Abra o formulário em nossa versão web e aproveite a simplicidade e agilidade na conclusão das informações!',
		MOBILE_IPAF_INFO_BUTTON: 'Ok, entendi',
		URL_INVALID: 'URL inválida',
		ACCOUNT_PENDING_ACTIVATION_TITLE: 'Aprovação de Conta Pendente',
		ACCOUNT_PENDING_ACTIVATION_INTRO:
			'Obrigado por se registrar em nosso portal de corretores. Estamos verificando suas informações para fornecer acesso ao nosso sistema de cotação. Este processo deve ser concluído em até 10 dias. Se tiver alguma dúvida ou se já tiverem passado mais de 10 dias, por favor entre em contato conosco pelo email contato@latuseguros.com ou via WhatsApp pelo número',
		ACCOUNT_PENDING_ACTIVATION_BTN: 'Explorar Latú Seguros',
		COMPANY_ALREADY_HAS_AN_IPAF_TITLE: 'Empresa já possui cadastro!',
		COMPANY_ALREADY_HAS_AN_IPAF_1:
			'A empresa que você está tentando cotar já está registrada sob o corretor de seguros',
		COMPANY_ALREADY_HAS_AN_IPAF_2:
			'Para obter uma cotação, por favor, entre em contato com eles através do seguinte e-mail:',
		COMPANY_ALREADY_HAS_AN_IPAF_3:
			'Se você acredita que isto é um erro e que a empresa não deveria estar registrada com a corretora, por favor, envie-nos um e-mail para',
		DAYS_LEFT: 'dias',
		EMAIL_IS_TAKEN_DO_NOT_START_POLICY:
			'O e-mail já tem uma conta, por favor tente com outro e-mail.',
		EMAIL_REGISTERED_ANOTHER_COMPANY:
			'O e-mail já tem uma conta, por favor tente com outro e-mail.',
		TAX_ID_OF_THIS_BROKER_ALREADY_EXISTS: 'O CNPJ fornecido já está em uso.',
		EMAIL_OF_THIS_BROKER_ALREADY_EXISTS:
			'O endereço de e-mail fornecido já está em uso.',
		BROKER_MONTH_SLIDER_APPROVED: 'Aprovado',
		BROKER_MONTH_SLIDER_NEED_ACTION: 'Enviar novamente',
		BROKER_MONTH_SLIDER_WAITING_APPROVAL: 'Aguardando Aprovação',
		START_PRE_IPAF: 'Iniciar questionário de seguros',
		SUCCESS_SCREEN_1_TITTLE: 'Questionário finalizado com sucesso!',
		SUCCESS_SCREEN_1_SUBTITTLE:
			'Sua cotação já está em andamento e você será notificado assim que ela estiver disponível.',
		SUCCESS_SCREEN_1_STEPS_A_TITLE: 'ETAPA 1',
		SUCCESS_SCREEN_1_STEPS_A_SUBTITLE: 'Coleta de dados',
		SUCCESS_SCREEN_1_STEPS_B_TITLE: 'ETAPA ATUAL ',
		SUCCESS_SCREEN_1_STEPS_B_SUBTITLE: 'Análise dos dados',
		SUCCESS_SCREEN_1_STEPS_C_TITLE: 'ETAPA 3',
		SUCCESS_SCREEN_1_STEPS_C_SUBTITLE: 'Apresentação da cotação',
		SUCCESS_SCREEN_1_STEPS_D_TITLE: 'ETAPA 4',
		SUCCESS_SCREEN_1_STEPS_D_SUBTITLE: 'Cobertura ativa',
		SUCCESS_SCREEN_1_BUTTON_FROM_LINK: 'Ir para Latú Seguros',
		SUCCESS_SCREEN_1_BUTTON_FROM_USER_APP: 'Fechar',
		SUCCESS_SCREEN_1_BUTTON_FROM_BROKER_APP: 'Fechar',
		SUCCESS_SCREEN_1_REMAINING_DAYS_INFO_A: '',
		SUCCESS_SCREEN_1_REMAINING_DAYS_INFO_B:
			'Obrigado pela informação, vamos começar a trabalhar em uma cotação agora mesmo.',
		IPAF_LISTENER_TITLE_GUEST:
			'Seu cliente realizou algumas alterações. Gostaria de atualizar o formulário e visualizar todas as modificações?',
		IPAF_LISTENER_TITLE_BROKER:
			'Seu corretor realizou algumas alterações. Gostaria de atualizar o formulário e visualizar todas as modificações?',
		IPAF_LISTENER_SUBTITLE:
			'Ao confirmar a atualização, suas respostas não salvas serão descartadas e o formulário será atualizado para a versão mais atual',
		TITLE_MODAL_FINISH_NOTIFICATION: 'O questionário já foi finalizado!',
		TEXT_MODAL_FINISH_NOTIFICATION:
			'Vamos redirecionar você à seguinte página para visualizar as próximas etapas da sua jornada.',
		WARNING_INFO_FINISH_NOTIFICATION_1:
			'Para visualizar todas as respostas do seu questionário de risco, acesse:',
		WARNING_INFO_FINISH_NOTIFICATION_2:
			' Quadro de tarefas > Painel de controle',
		ACTION_FINISH_NOTIFICATION: 'Entendido',
		WARNING_INFO_FINISH_NOTIFICATION_TO_GUEST:
			'Seu broker entrará em contato com você assim que a cotação estiver pronta.',
		INITIAL_QUESTIONS_TITLE: 'Perfil da empresa',
		INITIAL_QUESTIONS_SUBTITLE:
			'Estas informações introdutórias são importantes para a geração do questionário de forma mais precisa',
		EXIT_IPAF_LINK: 'Sair',
		IPAF_HEADER_TITLE: 'Questionário de seguros',
		POLICY_DETAIL_PENDING_SIGNATURE:
			'Seu cliente tem que assinar a proposta de seguro {{insurance_name}}! Enviamos um email diretamente a ele.',
		SIGNATARIO_EDIT_TOAST_SUCCESS:
			'Dados do signatário foram atualizados com sucesso!',
		ADMIN_EDIT_TOAST_SUCCESS:
			'Dados do administrador da conta foram atualizados com sucesso!',
		TITLE_MODAL_REJECT_IPAF:
			'Cotação negada por não atender à nossa política de aceitação',
		TEXT_MODAL_REJECT_IPAF:
			'Você poderá tentar novamente nos enviar este pedido em 3 meses.',
		TEXT_MODAL_WARNING_INFO_1:
			'Caso tenha dúvidas ou discorde de nossa decisão, entre em contato com o suporte da Latú pelo e-mail:',
		REJECT_MODAL_PRIMARY_ACTION: 'Ir a página inicial',
		REJECT_MODAL_SECONDARY_ACTION: 'Cadastrar outra empresa',
		QUOTE_SUBJECTIVITIES_TITLE: 'Subjetividades',
		EXCLUSIONS_GENERIC_INFO_BROKER:
			'Para uma descrição detalhada das coberturas e exclusões, consulte as condições gerais do produto.',
		EXCLUSIONS_GENERIC_INFO_USER:
			'Para uma descrição detalhada das coberturas e exclusões, consulte as condições gerais do produto.',
		BROKER_BANK_DETAILS_TITLE: 'Dados bancários',
		BROKER_BANK_DETAILS_SUBTITLE:
			'Os pagamentos de suas comissões serão efetuados diretamente nesta conta',
		BROKER_BANK_DETAILS_TAXATION_TITLE: 'Dados de tributação',
		BROKER_BANK_DETAILS_TAXATION_SUBTITLE:
			'Detalhamento de impostos baseado no seu regime fiscal e localidade da corretora',
		MULTI_URL_INVALID: 'Insira uma URL válida',
		DONT_HAVE_URL: 'Não possui URL',
		CHECK_DONT_HAVE_URL: 'Não possui website',
		ADD_NEW_URL: 'Incluir outra URL',
		LABEL_PRODUCT_CARD_SELECTION_APPROVED: 'Disponível para subscrição',
		LABEL_PRODUCT_CARD_SELECTION_REJECTED: 'Fora da política de risco',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_QUOTING: 'Apólice vigente',
		LABEL_PRODUCT_CARD_SELECTION_BEING_QUOTED: 'Cotação em andamento',
		TEXT_PRODUCT_SELECTION_WARNING_1: 'Para dúvidas, contate-nos via',
		TEXT_PRODUCT_SELECTION_WARNING_2: 'ou e-mail',
		LABEL_PRODUCT_CARD_SELECTION_CURRENT_POLICY_ANOTHER_BROKER:
			'Carta de nomeação',
		SUCCESS_MESSAGE: 'Questionário preenchido com sucesso!',
		CHECK_STATUS:
			'Confira o status atual das suas solicitações de cotação abaixo:',
		UNDER_REVIEW:
			'Em análise! Você será notificado pelo seu corretor em até 72h',
		EXIT: 'Sair',
		DATA_COLLECTION: 'Coleta de dados',
		RISK_ANALYSIS: 'Análise de risco',
		QUOTE_AVAILABLE: 'Cotação disponível',
		ACTIVE_COVERAGE: 'Cobertura ativa',
		UNDER_RISK_ANALYSIS: 'Em análise de risco',
		FOR_QUESTIONS: 'Para dúvidas, contate-nos via',
		TEXT_OR_BY_EMAIL_AT: 'ou e-mail',
		ERROR_SUCCESS_PAGE_TITLE: 'Não podemos apresentar cotação para este risco',
		ERROR_SUCCESS_PAGE_SUB_TITLE:
			'Confira o status atual das suas solicitações de cotação abaixo:',
		EO_DISCLAIMER_1: 'Seguro a base de Reclamação',
		EO_DISCLAIMER_2:
			'A Seguradora pagaráo ao Segurado as perdas que este venha a sofrer em consequência de Reclamações apresentadas contra ele por Terceiros visando imputar-lhe',
		EO_BASIC_COVERAGES_TITLE: 'Coberturas Básicas',
		EO_ADDITIONAL_COVERAGES_TITLE: 'Coberturas Adicionais',
		EO_EXTENSIONS_COVERAGES_TITLE: 'Extensões de Cobertura',
		REFRESH_DEPLOY_TITLE: 'Atualizações disponíveis!',
		REFRESH_DEPLOY_INFO:
			'Aplicamos melhorias para uma experiência ainda melhor. Recarregue a página para acessar as novidades.',
		REFRESH_DEPLOY_ACTION: 'Atualizar agora',
	},
};
